import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* LOGO + NOMBRE */}
        <div className="footer-brand">
          <img
            src="/assets/images/juan-mini.png"
            alt="Juan Carlos Mancha Ramos"
            className="footer-logo"
          />
          <span className="footer-name">
            Juan Carlos Mancha Ramos
          </span>
        </div>

        {/* LINKS */}
        <div className="footer-links">
          <Link to="/">Inicio</Link>
          <Link to="/desarrollo-web">Desarrollo Web</Link>
          <Link to="/ecommerce">E-commerce</Link>
          <Link to="/marketing-digital">Marketing</Link>
        </div>

        {/* CONTACTO */}
        <div className="footer-contact">
          <a
            href="https://wa.me/5493510000000"
            target="_blank"
            rel="noopener noreferrer"
          >
            WhatsApp
          </a>

          <a
            href="mailto:info@juancarlosmancharamos.ar"
          >
            Email
          </a>
        </div>

      </div>

      {/* COPY */}
      <div className="footer-bottom">
        © {new Date().getFullYear()} Juan Carlos Mancha Ramos · Córdoba, Argentina
      </div>
    </footer>
  );
}

export default Footer;